/* eslint-disable react/sort-comp */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import _, { cloneDeep } from "lodash";
import {
  Col,
  FormItem,
  Input,
  FormItemData,
  Row,
  Select,
  Button,
  Typography,
  Popconfirm,
  Alert,
  Modal,
  Collapse,
  SideBySideFormItem,
  Radio,
  Icon,
  Upload,
  Card,
} from "../../common/UIComponents";
import {  alertMessage, isEmpty, randomUUID } from "../../common/Common";
import I18n from "../../common/I18n";
import FormErrors from "../common/FormErrors";
import {
  changeStatusOfOrders,
  changeStatusToException,
  getBulkOrderComplete,
} from "../../api/OrdersApi";
import { fetchExceptionMessages } from "../../api/PreplanApi";
import ReasonWindow from "../common/ReasonWindow";
import AppConfig from "../../config/AppConfig";
import { fetchDriverList, fetchUsers, getCompletedOrderPod } from "../../api/UsersApi";
import DateTimeSelector from "../../common/DateTimeSelector";
import moment from "moment";
import { dummyRequest, renderAlertMessage } from "../../helpers/common";
import ChangeStatusFormList from "./ChangeStatusFormList";
import { TableImageColumn } from "../../common/TableImageColumn";
import DeleteIcon from "../common/DeleteIcon";
import userStore from "../../stores/UserStore";
import { sortedMsOrders } from "./helpers";
import { existingOutboundDockDatetime, defaultOutboundDockDatetime, isLtlOrganization, shouldCaptureOutboundDockTime } from "../../helpers/orders";

const { TextArea } = Input;
const { confirm } = Modal;
const { Panel } = Collapse
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: {
        All: "",
        New: "NEW",
        Received: "RECEIVED",
        OnHand: "ON_HAND",
        OnHold: "ON_HOLD",
        Verified: "VERIFIED",
        Preplan: "PREPLAN",
        Prepare: "PREPARE",
        Dispatched: "DISPATCHED",
        Assigned: "ASSIGNED",
        Completed: "COMPLETED",
        Exception: "EXCEPTION",
        Closed: "CLOSED",
        Archived: "ARCHIVED",
      },
      currentOrg: this.props.currentOrg,
      inProgress: false,
      errors: [],
      statusErrors: [],
      currentStatus: "",
      drivers: [],
      bulkOrders : [],
      selectedOrdersData : [],
      selectedOrders:[],
      bulkOrdersBackupData : [],
      organizationSettings : this.props.organizationSettings,
      selectedDriver: "",
      exceptionCode: "",
      leg_status : "",
      exceptionMessage: "",
      order: this.props.orderObject || {},
      preDispatchStatus: !this.props.isPending
        ? ["NEW", "RECEIVED", "VERIFIED", "ON_HAND", "PREPLAN"]
        : [],
      postDispatchStatus: !this.props.isPending
        ? ["PREPARE", "ASSIGNED", "DISPATCHED", "COMPLETED", "CLOSED"]
        : [],
      reason: "",
      orderStatus: this.props.currentStatus || "",
      // LTL Outbound Dock Time captured when a PLH/NLH order is completed from ON_HAND.
      outboundDockDatetime: defaultOutboundDockDatetime(this.props.orders?.[0] || {}),
      exceptions: ["NEW"],
      orders: this.props.orders || [],
      showReason: this.props.showReason || false,
      warehouseId: this.props.warehouseId || {},
      completedInfo: {},
      locationInfo: [],
      isMilitaryTime: props.is_military_time,
      complete_for: 'BOTH',
      // Update stays off until the user picks a status. Stops the listing gear
      // click (and the Select click) from landing on Update and completing.
      updateArmed: false,
    };
    this.armUpdateTimer = null;
    this.handleDriverChange = this.handleDriverChange.bind(this);
  }

  clearForm = () => {
    this.setState({
      currentItem: {},
      isNew: true,
    });
  };

  componentDidMount() {
    this.updateCurrentStatus()
    this.getExceptionMessages();
    this.getDriversList();
    this.getBulkOrderCompletion();
    // this.checkBulkStatus();
  }

  componentWillUnmount() {
    clearTimeout(this.armUpdateTimer);
  }

  armUpdate = () => {
    clearTimeout(this.armUpdateTimer);
    this.setState({ updateArmed: false });
    this.armUpdateTimer = setTimeout(() => {
      this.setState({ updateArmed: true });
    }, 400);
  };

  canSubmitStatusChange = () => {
    if (!this.state.updateArmed) return false;
    const hasStatus = !isEmpty(this.state.currentStatus);
    const hasLegStatus =
      (this.props.currentStatus === "VERIFIED" || this.props.currentStatus === "ON_HAND") &&
      !isEmpty(this.state.leg_status);
    return hasStatus || hasLegStatus;
  };

  componentDidUpdate(prevProps) {
    // Update state when showReason from parent changes
    if (prevProps.showReason !== this.props.showReason) {
      this.setState({ showReason: this.props.showReason });
    }
  }
  updateCurrentStatus = () => {
    const { selectedOrderStatus, matchedkey } = this.props;
    if (
      matchedkey &&
      selectedOrderStatus?.key !== this.state.orderStatus
    ) {
      const equalKey = Object.values(this.state.status).find(
        (value) => value === selectedOrderStatus.key
      );
      if (equalKey) {
        this.setState({ currentStatus: equalKey }, () => {
          this.armUpdate();
        });
      }
      // Uncomment if you want to reset `currentStatus` when no match is found
      // else {
      //   this.setState({ currentStatus: "" });
      // }
    }
  };
  
  handleApplyForAll = () => {
    const { completedInfo } = this.state;
    const isLinehaulLeg = (record) => {

    const isLinehaulDelivery = record?.order_label === "PLH" && record?.type_of_loc === "DELIVERY";
    const isLinehaulPickup = record?.order_label === "LHD" && record?.type_of_loc === "PICKUP";

    return isLinehaulDelivery || isLinehaulPickup;
  };
    const updatedOrders = this.state.bulkOrders.map((order) => {
      const updatedOrder = { ...order };
  
      const fieldsToUpdate = [
        "driver_id",
        "sign_by",
        "signer_title",
        "completed_date",
        "captured_at",
        "actual_start_datetime",
        "actual_end_datetime",
        "pod"
      ];
  
      if (order.location_status !== "COMPLETED" && !isLinehaulLeg(order)) {
        fieldsToUpdate.forEach((field) => {
          if (field && field !== "pod") {
            updatedOrder[field] = completedInfo[field] || null;
          }
        });
      if (!updatedOrder.pod || !updatedOrder.pod.picture?.url) {
          updatedOrder.pod = completedInfo.pod || null;
        }
      }
  
      updatedOrder.ack_id = `${randomUUID()}_n`;
  
      return updatedOrder;
    });
  
    const selectedOrders = this.state.bulkOrders
      .filter(order => order.location_status !== "COMPLETED" && !isLinehaulLeg(order))
      .map(order => order.location_id);
  
    this.setState({ bulkOrders: updatedOrders, selectedOrders });
  };
  


  handlePodDelete = (index) => {
    if (index === -1) {
      const completedInfo = { ...this.state.completedInfo };
      delete completedInfo.pod;
      this.setState({ completedInfo });
    } else {
      const bulkOrders = [...this.state.bulkOrders];
      delete bulkOrders[index].pod;
      this.setState({ bulkOrders });
    }
  };

  getCapturedInfo = (service_duration, nsr) => {
    const duration  = service_duration && _.isNumber(service_duration) && service_duration >= 10 ? (service_duration / 2) : 10;
    return ({
      sign_by: '',
      signer_title: '',
      completed_date: moment(),
      captured_at: !nsr ? moment() : null,
      actual_start_datetime: moment().subtract(Math.ceil(duration), "minute"),
      actual_end_datetime: moment().add(Math.floor(duration), "minute")
    })
  }

  setCapturedInfo = (loc) => {
    const duration  = loc.service_duration && loc.service_duration >= 10 ? Math.round(loc.service_duration / 2) : 10;
    return ({
      ...loc,
      captured_at: loc?.nsr ? moment() : null,
      completed_date: moment(),
      actual_start_datetime: moment().subtract((duration), "minute"),
      actual_end_datetime: moment().add((duration), "minute")
    })
  }

  // Outbound Dock Time: shown only for a single-order status change (order details
  // or the listing per-row gear), never in the bulk "Change Status" modal (Apply To
  // All), and only when BOTH legs are already COMPLETED and the order is moving
  // ON_HAND -> COMPLETED. Use the order's own status so listing "All" still matches.
  showOutboundDockField = () => {
    const orders = this.state.orders || [];
    const isBulk =
      orders.length !== 1 ||
      this.props.hasBulkOrders === true ||
      this.props.hasBulkOrders === "true";
    const order = orders[0] || {};
    return shouldCaptureOutboundDockTime({
      org: this.props.currentOrg,
      order,
      isBulk,
      fromStatus: order.status || this.state.orderStatus,
      toStatus: this.state.currentStatus,
    });
  };

  resolveOutboundDockDatetime = (order = this.state.orders?.[0], bulkOrders = this.state.bulkOrders) => {
    const deliveryRow = (bulkOrders || []).find(
      (loc) => String(loc.type_of_loc || "").toUpperCase() === "DELIVERY"
    );
    const fromBulk = deliveryRow
      ? existingOutboundDockDatetime({
          destination: deliveryRow,
          outbound_dock_datetime: deliveryRow.outbound_dock_datetime,
          timeZoneId: deliveryRow.timeZoneId,
        })
      : null;
    return fromBulk || defaultOutboundDockDatetime(order || {});
  };

  handleOutboundDockChange = (part, value) => {
    if (!value) return;
    const current = this.state.outboundDockDatetime
      ? moment(this.state.outboundDockDatetime)
      : moment();
    const updated =
      part === "date"
        ? moment(value).hour(current.hour()).minute(current.minute())
        : moment(current).hour(moment(value).hour()).minute(moment(value).minute());
    this.setState({ outboundDockDatetime: updated });
  };

  renderDateTimeField = (loc, dateLabel, timeLabel, key, showDate, showTime, dateReq, timeReq, index,isRequired,isDisabled,type) => {
    const { isMilitaryTime } = this.state;
    return(
      <DateTimeSelector
      dateKey={`${key}_${index}`}
      dateProps={{
        format: 'Do MMM YYYY',
        label : dateLabel,
        value : loc[key] ? loc[key] : null,
        onChange: (date) => {
          this.handleDetailsTimeChange(
              index,
              key,
              date,
              type,
          )
        },
        style: { width: '100%',marginBottom:'8px' },
        size : "small",
        disabledDate: (current) => {
          return (
              current && current.valueOf() > Date.now() // disabled the future dates
          )
        },
        dateRequire: dateReq,
        allowClear: false,
        dateKey: `date_${key}_${index}`,
        disabled: isDisabled,
      }}
      timeProps={ {
        allowClear: false,
        format: isMilitaryTime ? 'HH:mm' : 'hh:mm A',
        label: timeLabel,
        showTime: { format: isMilitaryTime ? 'HH:mm' : 'hh:mm A', use12Hours: !isMilitaryTime },
        showSecond: false,
        onChange: (time) => {
          this.handleDetailsTimeChange(
              index,
              key,
              time,
              type,
          )
        },
        style: { width: '100%', height: '100%', marginTop: '5px',marginBottom:'8px' },
        value :  loc[key] ? loc[key] : null,
        placeholder: 'Select Time',
        minuteStep: 1,
        className: "formMaterialTimePicker",
        isMilitaryTime,
        timeRequire: timeReq,
        timeKey: `time_${key}_${index}`,
        disabled: isDisabled,
      }}
      hideDate={!showDate}
      hideTime={!showTime}
      gridStyle={ { row: { type: "flex", gutter: 4 }, dateCol: { span: showDate && showTime ? 12 : (showDate ? 24 : showTime ? 0 : 12) }, timeCol: { span: showDate && showTime ? 12 : (showTime ? 24 : showDate ? 0 : 12) } } }
      FormItem={FormItemData}
      // FormItem={(formItemProps) => <FormItem {...formItemProps} requireColumn={isRequired} />}
  />
    )
  }

  fetchCompletedOrderPod = async (order_id, org_id) => {
    const payload = { order_id, org_id };
    let data = [];

    await getCompletedOrderPod(payload).then((res) => {
      if (res.success) {
        if (!_.isEmpty(res.data?.loc_pod_details)) {
          data = res.data.loc_pod_details;
        }
      }
    });

    const locationInfoUpdated = this.state.locationInfo.map((item) => {
      const subData = data.find(element => item.type_of_loc === element.location_type) ?? null;
      if (subData?.location_type == item.type_of_loc) {
        return {
          ...item,
          sign_by: !_.isEmpty(subData?.sign_by) ? subData.sign_by : item.sign_by,
          signer_title: !_.isEmpty(subData?.signer_title) ? subData.signer_title : item.signer_title,
          driver_id: !_.isEmpty(subData?.driver_code) ? subData.driver_code : item.driver_id
        }
      } else if (!_.isEmpty(data)) {
        return {
          ...item,
          sign_by: !_.isEmpty(data[0]?.sign_by) ? data[0].sign_by : item.sign_by,
          signer_title: !_.isEmpty(data[0]?.signer_title) ? data[0].signer_title : item.signer_title,
          driver_id: !_.isEmpty(data[0]?.driver_code) ? data[0].driver_code : item.driver_id
        };
      } else {
        return item;
      }
    })
    this.setState({ locationInfo: locationInfoUpdated, completedInfo })
  };

  setCompletedInfo = () => {
    const  { orders, currentStatus, complete_for } = this.state;
    const orderObject = orders?.length ? orders[0] : {};
    const locations = [];
    if(currentStatus === 'COMPLETED'){
      if(!_.isEmpty(orderObject)){
        if(!['T', 'LH'].includes(orderObject.type_of_order)){
          const label = ['R', 'TR'].includes(orderObject.type_of_order) ? 'PICKUP' : 'DELIVERY';
          const timeObject = this.getCapturedInfo(orderObject.service_duration, orderObject.nsr)
          locations.push({
            id: orderObject.id,
            order_id: orderObject.id,
            type_of_order: orderObject.type_of_order,
            customer_order_number: orderObject.customer_order_number,
            location_id: orderObject.cs_location_id,
            account_id: orderObject.account_id,
            label,
            type_of_loc: label,
            order_id: orderObject.id,
            ...timeObject,
            status: orderObject.status,
            nsr: !orderObject.nsr,
            //actual_end_datetime: moment().add((orderObject.service_duration || 20), "minute")
          })
        }else{
          const { origin, destination} = orderObject
          if(origin?.status !== 'COMPLETED'){
            const timeObject = this.getCapturedInfo(origin?.service_duration, orderObject.nsr)
            locations.push({
              id: orderObject.id,
              order_id: orderObject.id,
              type_of_order: orderObject.type_of_order,
              customer_order_number: orderObject.customer_order_number,
              location_id: origin?.location_id,
              account_id: orderObject.account_id,
              label: 'PICKUP',
              type_of_loc: 'PICKUP',
              ...timeObject,
              status: origin.status,
              nsr: !orderObject.nsr,
              //actual_end_datetime: moment().add((timeObject.service_duration || 20), "minute")
              });
            }
            if(!isEmpty(destination) && destination.location_id && destination.status !== 'COMPLETED'){
            const timeObject = this.getCapturedInfo(destination.service_duration, orderObject.nsr)
            locations.push({
              id: orderObject.id,
              order_id: orderObject.id,
              type_of_order: orderObject.type_of_order,
              customer_order_number: orderObject.customer_order_number,
              location_id: destination?.location_id,
              account_id: orderObject.account_id,
              label: 'DELIVERY',
              type_of_loc: 'DELIVERY',
              ...timeObject,
              status: destination.status,
              nsr: !orderObject.nsr,
              //actual_end_datetime: moment().add((timeObject.service_duration || 20), "minute")
            })
          }
          // LTL PWL orders carry a second (PWL) delivery leg nested under destination — surface it so
          // it can be completed manually with the default driver.
          const pwlDelivery = destination?.pwl_delivery;
          if (pwlDelivery && (pwlDelivery.location_id || pwlDelivery.id) && pwlDelivery.status !== 'COMPLETED') {
            const pwlTimeObject = this.getCapturedInfo(pwlDelivery.service_duration, orderObject.nsr);
            locations.push({
              id: orderObject.id,
              order_id: orderObject.id,
              type_of_order: orderObject.type_of_order,
              customer_order_number: orderObject.customer_order_number,
              location_id: pwlDelivery.location_id || pwlDelivery.id,
              account_id: orderObject.account_id,
              label: 'DELIVERY',
              type_of_loc: 'DELIVERY',
              ...pwlTimeObject,
              status: pwlDelivery.status,
              nsr: !orderObject.nsr,
              default_driver: 'true',
            });
          }
        }
        this.setState({
          locationInfo: [...locations],
          completedInfo: this.state.complete_for === 'PICKUP' ? locations.filter(loc => loc.type_of_loc === 'PICKUP') :[...locations],
        // }, () => {
        //   this.fetchCompletedOrderPod(this.state.orders[0]?.id, this.state.currentOrg?.id); 
        })
      }
    }
  }

  handleCompleteForChange = (element, value) => {
    const { locationInfo } = this.state;
    this.setState({
      [element]: value,
      completedInfo: value === 'PICKUP' ? locationInfo.filter(loc => loc.type_of_loc === 'PICKUP') :[...locationInfo],
    })
  }

  checkBulkStatus = () => {
    if (this.props.hasBulkOrders) {
      const { status } = this.state;
      delete status.Exception;
      this.setState({
        status,
      });
    }
  };

  handleClickUpdate = () => {
    if (!this.canSubmitStatusChange()) {
      return;
    }
    const { currentStatus } = this.state;
    const prevStatus = this.props.currentStatus;

    // LTL: moving a completed order back to On Hand needs no confirm popup / location / reason.
    const isLtlOnHandReopen = isLtlOrganization(this.props.currentOrg) && currentStatus === "ON_HAND";

    if (!isLtlOnHandReopen && prevStatus === "COMPLETED" && (currentStatus === "VERIFIED" || currentStatus === "ON_HAND")) {
      confirm({
        title: I18n.t("messages.order_deleted_from_route"),
        content: <span>{I18n.t("messages.proceed_confirm")}</span>,
        okText: "Yes",
        okType: "danger",
        cancelText: "No",
        onOk: () => {
          this.handleSave();
        },
        onCancel: () => {},
      });
    } else {
      this.handleSave();
    }
  };

  handleChange = (element, value) => {
    const { postDispatchStatus, preDispatchStatus, orderStatus } = this.state;

    const isRouteRemovalCase =
      element === "currentStatus" && postDispatchStatus.includes(orderStatus) &&
      preDispatchStatus.includes(value) &&
      !(orderStatus === "COMPLETED" && (value === "VERIFIED" || value === "ON_HAND"));

    const isCompletedToVerified =
      element === "currentStatus" &&
      orderStatus === "COMPLETED" &&
      (value === "VERIFIED" || value === "ON_HAND") &&
      // LTL On Hand reopen skips the reason/location capture — treated as a plain status change.
      !(isLtlOrganization(this.props.currentOrg) && value === "ON_HAND");

    if (isRouteRemovalCase) {
      let confirmTitle = I18n.t("messages.order_deleted_from_route");
      let confirmContent = <span>{I18n.t("messages.proceed_confirm")}</span>;

      confirm({
        title: confirmTitle,
        content: confirmContent,
        onOk: () => {
          this.setState({
            [element]: value,
            showReason: true,
          }, () => {
            this.setCompletedInfo()
          });
        },
        okText: "Yes",
        okType: "danger",
        cancelText: "No",
        onCancel: () => {},
      });
    } else if (isCompletedToVerified) {
      this.setState(
        {
          [element]: value,
          showReason: true,
        },
        () => {
          this.setCompletedInfo();
        }
      );
    }
      else{
        this.setState({
          [element]: value,
          ...(element === "currentStatus" && value === "COMPLETED"
            ? { outboundDockDatetime: this.resolveOutboundDockDatetime() }
            : {}),
        }, () => {
          if(element === "currentStatus"){
            this.setCompletedInfo()
          }
        });
      }
      if (element === "currentStatus" || element === "leg_status") {
        this.armUpdate();
      }
      if (element === "currentStatus" && typeof this.props.handleUpdateStatus === "function") {
        this.props.handleUpdateStatus(value);
      }
  };

  getDriversList(initial, cb) {
    this.setState({ inProgress: true });
    const orgId = this.props?.currentOrg?.id
    fetchDriverList({ orgId, includeWH: true }).then((result) => {
      if (result.success) {
        this.setState(
          {
            drivers: result.data.drivers.map((driver) => ({
              id: driver._id,
              employee_code: this.state?.currentOrg?.code === 'SSF' ? `${driver.first_name} ${driver.last_name} (${driver.employee_code})`: driver.employee_code,
            })),
            // selectedDriver: result.users[0].id, for making first driver to appear in dropdown
            inProgress: false,
          },
          () => {
            if (cb) {
              cb();
            }
          }
        );
      } else {
        renderAlertMessage(result.errors)
        this.setState({ inProgress: false });
      }
    });
  }

  getBulkOrderCompletion(initial, cb) {
    this.setState({ inProgress: true });
    const orderIds = this.state.orders
    //.filter((order) => order.type_of_order !== "MS")
    .map((order) => order?.id)
    .join(",");
    getBulkOrderComplete(orderIds).then((result) => {
      if (result.success) {
        const data =  result.data ? result.data.map(rec=> ({...rec, 
          completed_date: rec.completed_date ? moment(rec.completed_date) : null,
          order_label: this.state.orders.find(order => order.id === rec.order_id)?.order_label
        })) : [];

        let sortedData = sortedMsOrders(data);
        let bulkOrdersBackupData = result.data || [];

        if (this.props.clickFrom === "individualLocation") {
          const { completedInfo } = this.state;
          sortedData = sortedData
            .filter((order) => order.location_id === this.props.selectedOrderStatus.loc_id) 
            .map((order) => ({
              ...order,
              completed_date: completedInfo?.completed_date,
              captured_at: completedInfo?.captured_at,
              actual_start_datetime: completedInfo?.actual_start_datetime,
              actual_end_datetime: completedInfo?.actual_end_datetime,
            }));
          bulkOrdersBackupData = bulkOrdersBackupData.filter(order => order.location_id === this.props.selectedOrderStatus.loc_id).map(order => ({
            ...order,
            completed_date: completedInfo?.completed_date,
            captured_at: completedInfo?.captured_at,
            actual_start_datetime: completedInfo?.actual_start_datetime,
            actual_end_datetime: completedInfo?.actual_end_datetime,
          }));
        }

        this.setState(
          {
            bulkOrders: [...sortedData],
            bulkOrdersBackupData: bulkOrdersBackupData,
            selectedOrders: this.props.clickFrom === "individualLocation" ? [this.props.selectedOrderStatus.loc_id] : [],
            outboundDockDatetime: this.resolveOutboundDockDatetime(this.state.orders?.[0], sortedData),
            inProgress: false,
          },
          () => {
            if (cb) {
              cb();
            }
          }
        );
      } else {
        renderAlertMessage(result.errors)
        this.setState({ inProgress: false });
      }
    });
  }

  handleDriverChange = (value) => {
    this.setState({ selectedDriver: value });
  };

  getExceptionMessages = () => {
    this.setState({ inProgress: true });
    fetchExceptionMessages().then((result) => {
      if (result.success) {
        const exceptions = [
          ...result.exceptions,
          { exception_code: "CUSTOM", exception_message: "Custom Message" },
        ];
        this.setState({
          exceptions,
          inProgress: false,
        });
      } else {
        this.setState({
          inProgress: false,
          exceptions: [
            { exception_code: "CUSTOM", exception_message: "Custom Message" },
          ],
        });
        renderAlertMessage(result.errors)
      }
    });
  };

  handleSave = () => {
    if (!this.canSubmitStatusChange()) {
      return;
    }
    this.setState({ inProgress: true, errors: [] });
    const errors = [];

    if (this.state.exceptionCode === "CUSTOM" &&
      this.state.exceptionMessage === ""
    ) {
      errors.push("Message is required");
    }
    if (errors.length === 0) {
      if (this.state.currentStatus === "EXCEPTION") {
        const data = {
          order_id: this.state.orders.map((order) => order.id).join(","),
          exception_code: this.state.exceptionCode,
          exception_message:
            this.state.exceptionCode === "CUSTOM"
              ? this.state.exceptionMessage
              : "",
        };
        if (this.props.clickFrom == "individualLocation") {
          data.location_id = this.props.selectedOrderStatus?.loc_id;
        }
        changeStatusToException(data).then((result) => {
          if (result.success) {
            alertMessage(I18n.t("messages.processed"), 10);
            this.setState(
              {
                inProgress: false,
                errors: [],
                statusErrors: [],
              },
              () => {
                this.props.saveStatus();
              }
            );
          } else {
            this.setState({
              inProgress: false,
            });
            this.processErrors(result.errors);
            const errorOrders = result.errors
              ? result.errors.map((error) => error.order_number)
              : [];
            if (this.props.hasBulkOrders) {
              const errorOrders = result.errors
                ? result.errors.map((error) => error.order_number)
                : [];
              this.props.processErrors(errorOrders);
            }
          }
        });
      } else {
        const selectedWarehouses = localStorage.getItem("selectedWarehouses");
        let errors = [];
        const filteredOrders = this.state.bulkOrders.filter((loc) =>
          this.state.selectedOrdersData.includes(loc.location_id)
        );
        if(this.state.currentStatus === "COMPLETED"){
          filteredOrders.forEach((loc, index) => {
          if (loc.location_status !== "COMPLETED") {
            const tempErrors = [];
            const type_of_loc = loc.type_of_loc === null 
            ? (loc.type_of_order === "R" || loc.type_of_order === "TR" ? "P" : (loc.type_of_order === "D" || loc.type_of_order === "TD" ? "D" : ""))
            : (loc.type_of_loc === "PICKUP" ? "P" : "D");
            if (isEmpty(loc.sign_by) && loc.nsr) {
              tempErrors.push(I18n.t('order.sign_by'));
            }
            if (isEmpty(loc.captured_at)  && loc.nsr) {
              tempErrors.push(I18n.t('general.capture_date' ));
            }
            // if (!this.state.postDispatchStatus.includes(loc.status) && isEmpty(loc.driver_id || loc?.driver_details[0]?.id)) {
            //   tempErrors.push(I18n.t('general.Driver'));
            // }
            if (isEmpty(
              loc?.driver_details === null || !Array.isArray(loc?.driver_details)
                ? loc?.driver_id
                : loc.driver_details[0]?.id
            )) {
              tempErrors.push(I18n.t('general.Driver'));
            }
            if (isEmpty(loc.completed_date)) {
              tempErrors.push(I18n.t('info.completed_date' ));
            }
            if (isEmpty(loc.actual_start_datetime)) {
              tempErrors.push('Arrival Time');
            }
            if (isEmpty(loc.actual_end_datetime)) {
              tempErrors.push('Dept. Time');
            }
            if (tempErrors.length > 0) {
              errors.push(`${tempErrors.join(', ')} required for an order ${loc.customer_order_number}(${type_of_loc})`);
            }
            if (loc.actual_start_datetime && loc.actual_end_datetime) {
              const startDatetime = new Date(loc.actual_start_datetime);
              const endDatetime = new Date(loc.actual_end_datetime);
            
              if (endDatetime < startDatetime) {
                errors.push(`Departure time cannot be less than arrival time${loc.customer_order_number}(${type_of_loc})`);
              }
            }
            
            if (loc.actual_start_datetime && loc.captured_at) {
              const startDatetime = new Date(loc.actual_start_datetime);
              const capturedAt = new Date(loc.captured_at);
            
              if (capturedAt < startDatetime) {
                errors.push(`Captured time cannot be less than arrival time${loc.customer_order_number}(${type_of_loc})`);
              }
            }
            
            if (loc.actual_end_datetime && loc.captured_at) {
              const endDatetime = new Date(loc.actual_end_datetime);
              const capturedAt = new Date(loc.captured_at);
            
              if (endDatetime < capturedAt) {
                errors.push(`Departure time cannot be less than captured time${loc.customer_order_number}(${type_of_loc})`);
              }
            }
          }
          })
        }
        if(errors.length > 0){
          this.setState({ errors, inProgress: false });
        } else {
          const bulkOrdersData = _.cloneDeep(this.state.bulkOrders);
          const filteredOrders = bulkOrdersData.filter((loc) =>
            this.state.selectedOrdersData.includes(loc.location_id)
          );
          const data = {
            order_ids : this.state.orders.map((order) => order.id),
            status: this.state.currentStatus,
            exception_code: this.state.exceptionCode,
            leg_status : this.state.leg_status,
            exception_message:
              this.state.exceptionCode === "CUSTOM"
                ? this.state.exceptionMessage
                : "",
            deletion_reason: this.state.showReason ? this.state.reason : "",
            //driver_id: this.state.selectedDriver ? this.state.selectedDriver : '',
            warehouse_id: selectedWarehouses,
          };
          if (this.props.clickFrom == "individualLocation") {
            data.complete_location = true;
          }
          if (data.status === 'COMPLETED') {
            const filteredOrders = bulkOrdersData.filter((loc) =>
              this.state.selectedOrdersData.includes(loc.location_id)
            );
            const capturedInfo = filteredOrders
              .filter((loc) => loc.location_status !== 'COMPLETED')
              .map((loc) => {
              const completed_date = loc.completed_date;
              delete loc.completed_date;
              delete loc.label;

              const payload = {
                ...loc,
                signer_title: loc.signer_title || '',
                default_driver: loc.driver_id === 'default_driver' ? 'true' : 'false',
                captured_at: loc.captured_at
                    ? `${moment(completed_date).format("YYYY-MM-DD")} ${moment(loc.captured_at).format("HH:mm")}`
                    : null,
                actual_start_datetime: `${moment(completed_date).format("YYYY-MM-DD")} ${moment(loc.actual_start_datetime).format("HH:mm")}`,
                actual_end_datetime: `${moment(completed_date).format("YYYY-MM-DD")} ${moment(loc.actual_end_datetime).format("HH:mm")}`,
              }
              if(!this.state.postDispatchStatus.includes(
                loc.status
              )){
                payload.driver_id = loc.driver_id ? loc.driver_id : '';
              }
              if (payload.pod) {
                delete payload.pod.src;
              }
              return payload
            }) 
              .filter((item) => Object.keys(item).length > 0); // Filter out empty payloads

            data.captured_info = capturedInfo.length > 0 ? capturedInfo : [];
            const completedOrderIds = filteredOrders.map((order) => order.order_id).filter(Boolean);
            // Both-legs-already-completed (Outbound Dock Time) has no rows to select.
            // Keep the order id from the form so the status change and dock stamp still run.
            if (completedOrderIds.length > 0) {
              data.order_ids = completedOrderIds;
            }
            const podsInfo  = bulkOrdersData
              .filter((loc) => (loc?.pod?.picture_obj))
              .map((loc) => {
              const payload = {
                pod: loc.pod,
                location_id: loc.location_id,
                order_id: loc.order_id,
                account_id: loc.account_id,
                location_status: loc.location_status,
                };
                if (payload.pod) {
                  delete payload.pod.src;
                }
              return payload;
              })
              .filter((item) => Object.keys(item).length > 0);

            data.pods_info = podsInfo.length > 0 ? podsInfo : [];
          }
          if(this.state.currentStatus === 'ON_HOLD'){
            data.on_hold_reason = this.state.exceptionMessage
          }
          if (
            this.state.currentStatus === "COMPLETED" &&
            this.showOutboundDockField() &&
            this.state.outboundDockDatetime
          ) {
            data.status = "COMPLETED";
            data.outbound_dock_datetime = `${moment(this.state.outboundDockDatetime).format("YYYY-MM-DD")} ${moment(this.state.outboundDockDatetime).format("HH:mm")}`;
          }
          changeStatusOfOrders(data).then((result) => {
            if (result.success) {
              alertMessage(I18n.t("messages.processed"), 10);
              this.setState(
                {
                  inProgress: false,
                  errors: [],
                  statusErrors: [],
                  showReason: false,
                  reason: "",
                },
                () => {
                  this.props.saveStatus();
                }
              );
            } else {
              // alertMessage(result.errors[0], 'error', 10);
              this.setState({
                inProgress: false,
              });
              this.processErrors(result.errors);
              if (this.props.hasBulkOrders) {
                const errorOrders = result.errors
                  ? result.errors.map((error) => error.order_number)
                  : [];
                this.props.processErrors(errorOrders);
              }
            }
          });
        }

      }
    } else {
      this.setState({ errors, inProgress: false });
    }
  };

  updateSelectedLocations = (selectedOrdersData) =>{
    this.setState({
      selectedOrdersData : selectedOrdersData
    })
  }

  processErrors = (errors) => {
    if (errors?.length > 0) {
      const errorValue = errors[0];
      if (_.isString(errorValue)) {
        this.setState({
          errors,
          statusErrors: [],
        });
      } else if (_.isObject(errorValue)) {
        const statusErrors = [];
        errors.forEach((errObj) => {
          if (_.isObject(errObj) && errObj.order_number) {
            statusErrors.push(errObj);
          }
        });
        this.setState({
          errors: [],
          statusErrors,
        });
      }
    }
  };

  handleDetailsTimeChange = (index, element, value,type) => {
    const timeChangesInfo = type === 'list' ? 
    _.cloneDeep(this.state.bulkOrders) : 
    _.cloneDeep(this.state.completedInfo)
    //const handleTimings = type === 'list' ? "bulkOrders" : "completedInfo" 
    if(isEmpty(value)){
      value = null // moment()
    }
    if(index < 0){
      timeChangesInfo[element] = value
      this.setState({
        completedInfo : {...timeChangesInfo} ,
      });
    } else {
      timeChangesInfo[index][element] = value
        this.setState({
          bulkOrders: [...timeChangesInfo] ,
        });
    } 
  }

  getBase64 = (img, ackId) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.addEventListener("load", () =>
        resolve({ ackId, result: reader.result })
      );
      reader.addEventListener("error", (error) => reject(error));
    });
  };

  handleDetailsChange = async(index, element, value) => {
    const completedInfo = {...this.state.completedInfo}; 
       
    if(isEmpty(value)){
      value = ""
    }
    if(element === "pod") {
      const ack_id = `${randomUUID()}_n`;
      const data = await this.getBase64(value, ack_id);
        const { result } = data;
        completedInfo[element] = {
          ...completedInfo[element],
          picture_obj: value,
          src: result,
          ack_id: ack_id,
          picture_type: "normal",
          pic_title: "POD",
          pic_code: "POD",
        }
    } else{
      completedInfo[element] = value
    }
    this.setState({
      completedInfo,
    });
  }

  handleDetailsChangeList = async(index, element, value) => {
    const bulkOrders = [...this.state.bulkOrders]  
    let updatedSelectedOrders = [...this.state.selectedOrders]
    const order_rec = this.state.bulkOrders?.[index]
    if(isEmpty(value)){
      value = ""
    }
    if(element === "pod") {
      const ack_id = `${randomUUID()}_n`; 
      const data = await this.getBase64(value, ack_id);
    const { result } = data;
    bulkOrders[index][element] = {
          picture_obj: value,
          src: result,
          ack_id,
          picture_type: "normal",
          pic_title: "POD",
          pic_code: "POD",
        }
    } else if(element === "driver_id" && order_rec?.type_of_order === "MS"){ // for MS orders driver should be same
      bulkOrders[index].driver_id = value;
    } else{
      bulkOrders[index][element] = value;
    }
  
    // const record = bulkOrders[index];
    // const isComplete =
    //     !!record.driver_id ||
    //     (record?.driver_details === null || !Array.isArray(record?.driver_details)
    //       ? record?.driver_id
    //       : record?.driver_details[0]?.id) &&
    //     !!record.sign_by &&
    //     !!record.signer_title &&
    //     !!record.captured_at &&
    //     !!record.completed_date &&
    //     !!record.actual_start_datetime &&
    //     !!record.actual_end_datetime;
  
    // if (isComplete && !updatedSelectedOrders.includes(record.location_id)) {
    //   updatedSelectedOrders.push(record.location_id);
    // }
    this.setState({
      bulkOrders,
      selectedOrders: [...new Set(updatedSelectedOrders)],
    });
  }

  renderCapturedInfo = () => {
    const { completedInfo, isMilitaryTime } = this.state;
    const loc = {...completedInfo};
    return  (
      <div className="order_details_form marginTop10">
        {/* <h4>
          {loc.customer_order_number}-{loc.label}
        </h4> */}
        <Row gutter={16}>
          <Col span={6}>
            <FormItem label=" Signed By" name="signed_by" require={loc.nsr}>
              <Input
                data-testid="signed-by-input"
                type="text"
                value={loc.sign_by}
                maxLength={40}
                size="small"
                onChange={(e) =>
                  this.handleDetailsChange(index, "sign_by", e.target.value)
                }
                required
              />
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label=" Signed Title" name="signed_title">
              <Input
                data-testid="signed-title-input"
                type="text"
                value={loc.signer_title}
                size="small"
                onChange={(e) =>
                  this.handleDetailsChange(index, "signer_title", e.target.value)
                }
                required
              />
            </FormItem>
          </Col>
          {/* <Col span={12}>
            {this.renderDateTimeField(
              loc,
              I18n.t("general.capture_date"),
              I18n.t("general.capture_time"),
              "captured_at",
              true,
              true,
              true,
              true,
              index
            )}
          </Col> */}
           <Col span={6}>
            {this.renderDateTimeField(
              loc,
              "Completed Date",
              "Completed Time",
              "completed_date",
              true,
              false,
              loc.nsr,
              false,
              index
            )}
          </Col>
          <Col span={6}>
            {this.renderDateTimeField(
              loc,
              "Captured Date",
              "Captured Time",
              "captured_at",
              false,
              true,
              false,
              loc.nsr,
              index
            )}
          </Col>
          { !this.state.postDispatchStatus.includes(
                    loc.status
                  ) && <Col span={6}>
            <FormItem label="Driver" require>
              <Select
                data-testid="driver-dropdown"
                style={{ width: "100%" }}
                //onChange={this.handleDriverChange}
                onChange={(e) => this.handleDetailsChange(index, "driver_id", e)}
                value={loc.driver_id}
                size="small"
                filterOption={(input, option) => {
                  if (option.props.children) {
                    return (
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }
                }}
                showSearch
              >
                <Select.Option key={"driver"} value={""}>
                  --select--
                </Select.Option>
                <Select.Option key={"default_driver"} value={"default_driver"}>
                  Default Driver
                </Select.Option>
                {this.state.drivers.map((driverDetail) => (
                  <Select.Option key={driverDetail.id} value={driverDetail.id}>
                    {driverDetail.employee_code}
                  </Select.Option>
                ))}
              </Select>
            </FormItem>
          </Col>
          }
          
          <Col span={6}>
            {this.renderDateTimeField(
              loc,
              "Arrival Date",
              "Arrival Time",
              "actual_start_datetime",
              false,
              true,
              false,
              true,
              index
            )}
          </Col>
          <Col span={6}>
            {this.renderDateTimeField(
              loc,
              "Dept. Date",
              "Dept. Time",
              "actual_end_datetime",
              false,
              true,
              false,
              true,
              index
            )}
          </Col>
        </Row>
      </div>
    );
  };

  renderApplyAllFields = () => {
    const { completedInfo, postDispatchStatus,bulkOrders,selectedOrders } = this.state;
    const now = moment();
    const updatedCompletedInfo = {
      ...completedInfo,
      completed_date: completedInfo?.completed_date || now,
      captured_at: completedInfo?.captured_at || now,
      actual_start_datetime: completedInfo?.actual_start_datetime || now.clone().subtract(10, 'minutes'),
      actual_end_datetime: completedInfo?.actual_end_datetime || now.clone().add(10, 'minutes'),
    };

    if (!completedInfo?.completed_date || !completedInfo?.captured_at || 
        !completedInfo?.actual_start_datetime || !completedInfo?.actual_end_datetime) {
      this.setState({ completedInfo: updatedCompletedInfo });
    }

    const loc = { ...updatedCompletedInfo };
      return (
      
        <div className="order_details_form marginTop10" key={-1}>
          {this.props?.clickFrom !== "individualLocation" && 
          <Card 
            style={{
            border: '1px solid black', 
            borderRadius: '4px', 
            padding: '5px', 
            marginTop: '10px',
            marginBottom :'10px'
        }}
        bodyStyle={{
          padding: '0px',
        }}
      >
        <Row gutter={16} data-testid="apply-all">
          {!postDispatchStatus.includes(loc.status) && (
            <Col span={3}>
              <FormItem label="Driver" required>
                <Select
                  data-testid="driver-dropdown"
                  style={{ width: "100%" }}
                  onChange={(e) => this.handleDetailsChange(-1, "driver_id", e)}
                  value={loc.driver_id}
                  size="small"
                  showSearch
                  filterOption={(input, option) => {
                    const children = option.props.children;
                    if (children && children.length > 0) {
                      if (Array.isArray(children)) {
                        return children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0;
                      } else {
                        return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                      }
                    }
                  }}
                >
                  <Select.Option key={"driver"} value={""}>
                    --select--
                  </Select.Option>
                  {this.state.organizationSettings?.remove_default_driver === "true" && (
                  <Select.Option key={"default_driver"} value={"default_driver"}>
                    Default Driver
                  </Select.Option>
                  )}
                  {this.state.drivers.map((driverDetail) => (
                    <Select.Option key={driverDetail.id} value={driverDetail.id}>
                      {driverDetail.employee_code}
                    </Select.Option>
                  ))}
                </Select>
              </FormItem>
            </Col>
          )}
          <Col span={3}>
            <FormItem label="Signed By" required>
              <Input
                data-testid="signedBy-input"
                type="text"
                value={loc.sign_by}
                maxLength={40}
                size="small"
                onChange={(e) =>
                  this.handleDetailsChange(-1, "sign_by", e.target.value)
                }
              />
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem label=" Signed Title" name="signed_title">
              <Input
                data-testid="signed-title-input"
                type="text"
                value={loc.signer_title}
                size="small"
                onChange={(e) =>
                  this.handleDetailsChange(-1, "signer_title", e.target.value)
                }
                required
              />
            </FormItem>
          </Col>
          <Col span={3}>
            {this.renderDateTimeField(
              loc,
              "Completed Date",
              "Completed Time",
              "completed_date",
              true,
              false,
              loc.nsr,
              false,
              -1
            )}
          </Col>
          <Col span={3}>
            {this.renderDateTimeField(
              loc,
              "Captured Date",
              "Captured Time",
              "captured_at",
              false,
              true,
              false,
              loc.nsr,
              -1
            )}
          </Col>
          <Col span={3}>
            {this.renderDateTimeField(
              loc,
              "Arrival Date",
              "Arrival Time",
              "actual_start_datetime",
              false,
              true,
              false,
              false,
              -1
            )}
          </Col>
          <Col span={3}>
            {this.renderDateTimeField(
              loc,
              "Dept. Date",
              "Dept. Time",
              "actual_end_datetime",
              false,
              true,
              false,
              false,
              -1
            )}
          </Col>
          <Col span={3}  style={{ marginTop: "0px",paddingLeft:'10px' }}>
          <FormItem label="Pod" requireColumn={false} >
            {this.state?.completedInfo?.pod?.src ? (
              <div style={{ display: "flex", alignItems: "center" }}>
            <TableImageColumn
                record={[this.state.completedInfo?.pod?.src]}
                width="86"
                height="30"
                marginLeft = "3"
                style={{marginTop:'-14px'}}
              />&nbsp;&nbsp;
              <DeleteIcon 
                style={{ cursor: 'pointer', marginLeft: '10px' }}
                handleClick={() => this.handlePodDelete(-1)}
              />
              </div>
            ) : (
            <Upload
              // listType="picture-card"
              showUploadList={false}
              width ='88px'
              height='30px'
              beforeUpload={(file) => {
                this.handleDetailsChange(-1, "pod", file);
                return false;
              }}
              multiple={false}
              customRequest={dummyRequest}
            >
              <Button data-testid="pod-upload-button" size='medium' style={{marginTop:'-2px',fontSize:'21px'}}>
                <Icon type="link" 
                color="#576EC1" 
                width="24px" 
                height="24px" 
                style={{ transform: 'rotate(45deg)' }}/>
              </Button>
            </Upload>
            )}
            </FormItem>
          </Col>
        </Row>
        <Row style={{ display: 'flex', alignItems: 'center' }}>
          <Col>
            <Icon type="info-circle" theme="twoTone" style={{ fontSize: '16px', marginRight: '8px' }} />
          </Col>
          <Col span={21}>
            <h4 style={{ margin: 0 }}>
              Above provided details will be applied to all the below selected orders and status will be changed to completed.
            </h4>
          </Col>
          <Col span={2}>
          <Button 
            data-testid="apply-all-button"
            type="primary" 
            style={{ marginTop: "16px",marginLeft:'-9px' }} 
            onClick={this.handleApplyForAll}
          >
            Apply To All
          </Button>
          </Col>
        </Row>
        <Row style={{ display: 'flex', alignItems: 'center',marginTop:'-8px' }}>
          <Col>
            <Icon type="info-circle" theme="twoTone" style={{ fontSize: '16px', marginRight: '8px' }} />
          </Col>
          <Col>
            <h4 style={{ margin: 0 }}>
              Send completion status updates & email notifications for below orders.
            </h4>
          </Col>
        </Row>
        {/* <Row style={{ display: 'flex', alignItems: 'center',marginTop:'3px' }}>
          <Col>
            <Icon type="info-circle" theme="twoTone" style={{ fontSize: '16px', marginRight: '8px' }} />
          </Col>
          <Col>
            <h4 style={{ margin: 0 }}>
              Multistop orders cannot be completed manually.
            </h4>
          </Col>
        </Row> */}
        <Row style={{ display: 'flex', alignItems: 'center',marginTop:'3px' }}>
          <Col>
            <Icon type="info-circle" theme="twoTone" style={{ fontSize: '16px', marginRight: '8px' }} />
          </Col>
          <Col>
            <h4 style={{ margin: 0 }}>
            Order will be automatically moved to COMPLETED status when both Pickup and Delivery are completed.
            </h4>
          </Col>
        </Row>
            </Card>
          }

        <Row data-testid="selected-orders-list">
        <ChangeStatusFormList
          clickFrom={this.props.clickFrom}
          data={this.state.bulkOrders || []}
          scroll={{ x: "max-content" }}
          organizationSettings = {this.props.organizationSettings}
          bulkOrdersBackupData = {this.state.bulkOrdersBackupData}
          drivers={this.state.drivers}
          pagination={{ position: 'none' }}
          renderDateTimeField={this.renderDateTimeField}
          handlePodDelete={this.handlePodDelete}
          isMilitaryTime={this.state.isMilitaryTime}
          completedInfo={this.state.completedInfo}
          handleDetailsChange={this.handleDetailsChangeList}
          handleOrderSelection={this.handleOrderSelection}
          updateSelectedLocations={this.updateSelectedLocations}
          selectedOrders={selectedOrders}
          rowClassName={(record) => {
            if(this.state.bulkOrders.filter((rec) => rec.order_id === record.order_id).length > 1){
              return "";
            }
            return "";
          }}
        />
        </Row>
      </div>
    );
  };
  

  render() {
    const currentIndex = Object.values(this.state.status).indexOf(
      this.state.orderStatus
    );
    const isAdmin = userStore.admin();
    const isAfi = this.state?.currentOrg?.code === "AFI"
    return (
      <div className="marginTop10 change_status_form" data-testid="status-modal">
        <Row gutter={16}>
          <Col xs={24}>
            <Row
              style={{
                padding: "10",
                backgroundColor: "#fff",
              }}
            >
              <Row>
                <Col xs={24}  style={{ paddingBottom: 10 }}>
                {!this.showOutboundDockField() && (
                <Row type="flex" justify="space-between" align="middle">
                  <Col>
                    <Typography.Text strong>
                      Current Status :{" "}
                      {currentIndex >= 0
                        ? Object.keys(this.state.status)[currentIndex]
                        : this.state.orderStatus}
                    </Typography.Text>
                  </Col>
                  <Col>
                    <Row type="flex" align="middle">
                    <Col className="textBold">Select Status</Col>
                     <Col style={{ margin: "0 8px" }}>:</Col>
                     <Col>
                     <Select
                      data-testid="select-status-dropdown"
                      style={{ width: 200 }}
                      className="routes-input"
                      onChange={(e) => this.handleChange("currentStatus", e)}
                      defaultValue="Change Status"
                      value={this.state.currentStatus}
                      size="small"
                      filterOption={(input, option) =>
                         option?.props?.children
                            ?.toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {Object.keys(this.state.status).map((key, index) => {
                        const unwantedKeys = [
                          "Preplan",
                          "Prepare",
                          "Dispatched",
                          "Assigned",
                          "Archived",
                        ];

                        const isLtlOrg = isLtlOrganization(this.props.currentOrg);
                        if (isLtlOrg) {
                          unwantedKeys.push("Verified");
                        } else {
                          // Only On Hand is LTL-only (no non-LTL label in the FEP-5201
                          // spec). ON_HOLD exists for every org and is a relabel for LTL
                          // ("Hold"), not an LTL-exclusive status - see the displayLabel
                          // branch below.
                          unwantedKeys.push("OnHand");
                        }

                        // For an LTL org, On Hand is the relabel of Verified and is always
                        // available (no RECEIVED / storage-transfer restriction). Non-LTL orgs
                        // already hide it via the branch above.

                        // Don't show pending/rejected as options if current status is pending
                        if (this.state.orderStatus === "PENDING") {
                          unwantedKeys.push("Pending", "Rejected");
                        }

                        if (this.state.orderStatus === "REJECTED") {
                          unwantedKeys.push("Rejected");
                        }

                        const hideClosedKey = isAfi && !isAdmin && ["Closed"].includes(key);
                        const isUnwantedKey = unwantedKeys.includes(key);
                        const isNotAllKey = key !== "All";
                        const isNotSameOrderStatus =
                          this.state.status[key] !== this.state.orderStatus;

                        if (
                          !isUnwantedKey &&
                          !hideClosedKey &&
                          isNotAllKey &&
                          isNotSameOrderStatus
                        ) {
                          // LTL relabels: On Hold -> "Hold". Both OnHold and OnHand are
                          // spaceless keys, so render them with a space otherwise.
                          const displayLabel =
                            key === "OnHold"
                              ? isLtlOrg
                                ? "Hold"
                                : "On Hold"
                              : key === "OnHand"
                              ? "On Hand"
                              : key;
                          return (
                            <Select.Option value={this.state.status[key]} key={index}>
                              {displayLabel}
                            </Select.Option>
                          );
                        }

                        return null; // Skip unwanted keys
                      })}
                    </Select>
                     </Col>
                  </Row>
                  </Col>
                </Row>
                )}

                  {(["NEW", "RECEIVED", "VERIFIED", "ON_HAND", "ASSIGNED"].includes(
                    this.state.orderStatus
                  ) || (this.state.orders?.length === 1 && this.state.orders[0].status !== 'COMPLETED')) &&
                    this.state.currentStatus === "COMPLETED" &&
                    !this.showOutboundDockField() && (
                      <>
                      {this.renderApplyAllFields()}
                      {/* {this.renderCapturedInfo()} */}
                      </>
                    )}
                  {this.showOutboundDockField() && (
                    <Row gutter={16} type="flex">
                      <Col xs={24}>
                        <DateTimeSelector
                          dateKey="outbound_dock_date"
                          dateProps={{
                            format: "Do MMM YYYY",
                            label: I18n.t("general.outbound_dock_time"),
                            require: true,
                            value: this.state.outboundDockDatetime,
                            onChange: (date) => this.handleOutboundDockChange("date", date),
                            style: { width: "100%", marginBottom: "8px" },
                            size: "small",
                            allowClear: false,
                          }}
                          timeProps={{
                            format: this.state.isMilitaryTime ? "HH:mm" : "hh:mm A",
                            label: "Time",
                            require: true,
                            value: this.state.outboundDockDatetime,
                            onChange: (time) => this.handleOutboundDockChange("time", time),
                            style: { width: "100%" },
                            size: "small",
                            allowClear: false,
                            isMilitaryTime: this.state.isMilitaryTime,
                          }}
                        />
                      </Col>
                    </Row>
                  )}
                </Col>
                <Col xs={24} style={{ paddingBottom: 10 }}>
                {this.props.currentStatus === "COMPLETED" &&
                   (this.state.currentStatus === "VERIFIED" || this.state.currentStatus === "ON_HAND") &&
                   !(isLtlOrganization(this.props.currentOrg) && this.state.currentStatus === "ON_HAND") &&
                   (this.state.orders?.length === 1 && ["T"].includes(this.state.orders[0].type_of_order)) && (
                    <Col span={12}>
                    <Row gutter={16} type="flex">
                      <Col className="textBold" xs={23} md={6} style={{ whiteSpace: "nowrap" }}>Location</Col>
                      <Col xs={1} md={1}> : </Col>
                      <Col xs={24} md={8}>
                        <Select
                          data-testid="location-dropdown"
                          style={{ width: 130 }}
                          className="routes-input"
                          onChange={(e) => this.handleChange("leg_status", e)}
                          value={this.state.leg_status || ""}
                          size="small"
                            filterOption={(input, option) =>
                            {
                              if (option.props.children) {
                                return option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            }
                            }
                          showSearch
                        >
                            <Select.Option value="PICKUP">Pickup</Select.Option>
                            <Select.Option value="DELIVERY">Delivery</Select.Option>
                            <Select.Option value="BOTH">Both</Select.Option>
                        </Select>
                      </Col>
                    </Row>
                    </Col>
                    )}
                </Col>
                <Col xs={24} style={{ paddingBottom: 10 }}>
                {(this.props.currentStatus === "VERIFIED" || this.props.currentStatus === "ON_HAND") && isEmpty(this.state.currentStatus) &&
                    this.state.orders.length === 1 &&
                    ["T"].includes(this.state.orders[0]?.type_of_order) && (
                    <Col span={12}>
                    <Row gutter={16} type="flex">
                      <Col className="textBold" xs={23} md={6} style={{ whiteSpace: "nowrap" }}>Location</Col>
                      <Col xs={1} md={1}> : </Col>
                      <Col xs={24} md={8}>
                        <Select
                          data-testid="location-select"
                          style={{ width: 130 }}
                          className="routes-input"
                          onChange={(e) => this.handleChange("leg_status", e)}
                          value={this.state.leg_status || ""}
                          size="small"
                            filterOption={(input, option) =>
                            {
                              if (option.props.children) {
                                return option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            }
                            }
                          showSearch
                        >
                            <Select.Option value="PICKUP">Pickup</Select.Option>
                            <Select.Option value="DELIVERY">Delivery</Select.Option>
                            <Select.Option value="BOTH">Both</Select.Option>
                        </Select>
                      </Col>
                    </Row>
                    </Col>
                    )
                }
                </Col>
                <Col xs={24} style={{ paddingBottom: 10 }}>
                  {this.state.currentStatus === "EXCEPTION" && (
                    <Row gutter={16} type="flex">
                      <Col className="textBold" xs={23} md={6}>Select Exception</Col>
                      <Col xs={1} md={1}> : </Col>
                      <Col xs={24} md={17}>
                        <Select
                          data-testid="exception-dropdown"
                          style={{ width: 200 }}
                          className="routes-input"
                          onChange={(e) => this.handleChange("exceptionCode", e)}
                          defaultValue="Change Status"
                          value={this.state.exceptionCode}
                          size="small"
                            filterOption={(input, option) =>
                            {
                              if (option.props.children) {
                                return option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            }
                            }
                          showSearch
                        >
                          {this.state.exceptions.map((excep) => (
                            <Select.Option
                              value={excep.exception_code}
                              key={excep.exception_code}
                            >
                              {excep.exception_message}
                            </Select.Option>
                          ))}
                        </Select>
                      </Col>
                    </Row>
                  )}
                  {(this.state.exceptionCode === "CUSTOM" || this.state.currentStatus === "ON_HOLD" )&& (
                    <div className="marginTop10">
                      <FormItem label={I18n.t("messages.reason_to_change")}>
                           <TextArea
                            data-testid="message-input"
                            rows={4}
                            placeholder={I18n.t("general.message")}
                            className="sop-form-textArea"
                            value={this.state.exceptionMessage}
                            onChange={(e) =>
                              this.handleChange("exceptionMessage", e.target.value)
                            }
                          />
                        </FormItem>
                    </div>
                  )}
                  {this.state.showReason && this.state.currentStatus !== "ON_HOLD" && (
                    <div>
                      <FormItem label={I18n.t("messages.reason_to_change")}>
                        <ReasonWindow
                          reasonElement="reason"
                          reasonValue={this.state.reason}
                          handleOnChange={this.handleChange}
                          showButtons={false}
                        />
                      </FormItem>
                    </div>
                  )}
                </Col>
              </Row>
              {this.props.hasBulkOrders && (<Row>
                <Col span={ 24 } className='selecetdOrderPanel'>
                    <Collapse
                      bordered={false}
                      defaultActiveKey={["1"]}
                      className="marginTop10"
                    >
                      <Panel
                        header="Selected Orders"
                        key="1"
                        style={{
                          marginTop: "10px",
                        }}
                      >
                        <p style={{ maxHeight: 70, overflowY: "auto" }}>
                          {this.state.orders.map((order) => order.customer_order_number).join(", ")}
                        </p>
                      </Panel>
                    </Collapse>
                </Col>
              </Row>)}
              <Row>
                <Col
                  offset={1}
                  xs={22}
                  style={{ padding: 10, textAlign: "center" }}
                >
                  <Button type="danger" onClick={this.props.closeModal} data-testid="cancel-status-button">
                    Cancel
                  </Button>
                  &nbsp; &nbsp;
                 
                    <Button
                      onClick={this.handleClickUpdate}
                      type="primary"
                      loading={this.state.inProgress}
                      disabled={
                        !this.state.updateArmed ||
                        (
                        !(
                          (this.props.currentStatus === "VERIFIED" || this.props.currentStatus === "ON_HAND") &&
                          !isEmpty(this.state.leg_status)
                        ) &&
                        (
                        !this.state.currentStatus ||
                        (this.state.currentStatus === "EXCEPTION" &&
                          isEmpty(this.state.exceptionCode)) ||
                        (this.state.currentStatus === "EXCEPTION" &&
                          this.state.exceptionCode === "CUSTOM" &&
                          isEmpty(this.state.exceptionMessage)) ||
                        (this.state.showReason && this.state.reason.length < 10)
                        )
                        )
                      }
                      icon="save"
                      data-testid="update-status-button"
                    >
                    {this.props.clickFrom === "individualLocation" ? "Complete" : "Update"}
                    </Button>
                
                </Col>
              </Row>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            {/* FormErrors(this.state.errors) */}
            {this.state.statusErrors.length > 0 && (
              <Alert
                message="Error"
                description={
                  <div>
                    {this.state.statusErrors.map((err) =>
                      _.isObject(err) ? (
                        <Row>
                          <Col xs={8} className="textBold">
                            {err.order_number}
                          </Col>
                          <Col xs={16}>
                            {_.isArray(err.errors) ? err.errors.join(",") : ""}
                          </Col>
                        </Row>
                      ) : (
                        <Fragment />
                      )
                    )}
                  </div>
                }
                type="error"
                closable={false}
              />
            )}
            {this.state.errors.length > 0 && FormErrors(this.state.errors)}
          </Col>
        </Row>
      </div>
    );
  }
}

Form.propTypes = {
  closeModal: PropTypes.func.isRequired,
  saveStatus: PropTypes.func.isRequired,
  orderObject: PropTypes.shape().isRequired,
  currentStatus: PropTypes.string.isRequired,
};

export default Form;